import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { FacilityEffects } from '@facility/state';

import { FacilityLookupDialogComponent } from './facility-lookup-dialog/facility-lookup-dialog.component';
import { FacilityLookupDialogGridComponent } from './facility-lookup-dialog/grid/grid.component';

@NgModule({
  declarations: [FacilityLookupDialogComponent, FacilityLookupDialogGridComponent],
  imports: [CommonModule, SharedModule, ComponentsModule, TranslocoModule, EffectsModule.forFeature([FacilityEffects])],
  exports: [FacilityLookupDialogComponent],
})
export class FacilityModule {}
